import { Link, Theme, Typography, styled } from '@material-ui/core';

export const NotificationsItemContainer = styled('div')<Theme>(({ theme }) => ({
  height: '100%',
  width: '100%',
}));

export const NotificationsItemWrapper = styled('div')<Theme>(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  borderBottom: `1px solid ${theme.config.appbarColors.borderColor}`,
}));

export const NotificationsItemTitle = styled(Typography)<Theme>(({ theme }) => ({}));

export const NotificationsItemDate = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: 400,
  fontSize: '13px',
  color: theme.palette.secondary.main,
}));

export const NotificationsItemLink = styled(Link)<Theme>(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 700,
  color: theme.palette.ternary.main,
}));
